import parseHTML from "../../lib/dom/funciones/parse_html";
var desplazadorDeTestimonios = function (linea, direccion) {
    var elemento = linea.querySelector('li:nth-child(2)');
    return function () {
        return linea.scroll({
            left: linea.scrollLeft + direccion * elemento.offsetLeft,
            behavior: 'smooth'
        });
    };
};
var testimonios = function () {
    Array.from(document.querySelectorAll('.bloque--testimonios')).forEach(function (el) {
        var anterior = parseHTML('<button class="linea_de_tiempo__anterior" disabled>Anterior</button>'), siguiente = parseHTML('<button class="linea_de_tiempo__siguiente">Siguiente</button>'), navegacion = parseHTML('<div class="linea_de_tiempo__navegacion"></div>');
        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);
        el.appendChild(navegacion);
        var lista = el.querySelector('ul');
        anterior.addEventListener('click', desplazadorDeTestimonios(lista, -1));
        siguiente.addEventListener('click', desplazadorDeTestimonios(lista, 1));
        lista.addEventListener('scroll', function () {
            anterior.disabled = lista.scrollLeft === 0;
            siguiente.disabled = Math.abs(lista.scrollLeft + lista.clientWidth - lista.scrollWidth) < 2;
        });
        var videos = Array.from(el.querySelectorAll('video'));
        videos.forEach(function (video) {
            video.controls = false;
            var videoGrande = parseHTML('<div class="video-grande"></div>');
            videoGrande.addEventListener('click', function (e) {
                if (e.target === videoGrande) {
                    cierraVideo();
                }
            });
            videoGrande.addEventListener('transitionend', function () {
                if (getComputedStyle(videoGrande).opacity === '0') {
                    videoGrande.remove();
                }
            });
            var cierraVideo = function () {
                videoGrande.style.opacity = '0';
            };
            var abreVideo = function (e) {
                document.body.appendChild(videoGrande);
                var clon = video.cloneNode(true);
                clon.controls = true;
                videoGrande.innerHTML = '';
                videoGrande.appendChild(clon);
                videoGrande.style.opacity = '0';
                clon.addEventListener('pause', cierraVideo);
                requestAnimationFrame(function () {
                    clon.play();
                    videoGrande.style.opacity = '1';
                });
                e.preventDefault();
            };
            video.addEventListener('click', abreVideo);
        });
    });
};
export default testimonios;
